import { render } from "./UserRegister.vue?vue&type=template&id=3c46e1c1&scoped=true"
import script from "./UserRegister.vue?vue&type=script&lang=js"
export * from "./UserRegister.vue?vue&type=script&lang=js"

import "./UserRegister.vue?vue&type=style&index=0&id=3c46e1c1&scoped=true&lang=css"

import exportComponent from "/vercel/path0/Source Frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c46e1c1"]])

export default __exports__